module.exports = __webpack_public_path__ + "static/media/Recykle Full logo.ff325875.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Recykle Full logo.png
// module id = 285
// module chunks = 0